
import toast from "react-hot-toast";
import Api from "./ApiConfigs";



// GET request
export const getRequest = async (url, params = {}) => {
  try {
    const response = await Api.get(url, { params });

    // Check if the response is successful
    if (response?.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response?.status}`);
    }
  } catch (error) {
    console.error("Error in GET request:", error);
    
    // Enhanced error handling
    if (error.response) {
      // Server error (e.g., 401, 404, 500, etc.)
      throw new Error(`API error: ${error.response?.data || error.message}`);
    } else if (error.request) {
      // Network error (e.g., no response from server)
      throw new Error('No response from the server. Please check your network connection.');
    } else {
      // Unexpected error (e.g., request misconfiguration)
      throw new Error(`Unexpected error: ${error.message}`);
    }
  }
};

// POST request
export const postRequest = async (url, data = {}) => {
  try {
    const response = await Api.post(url, data);
    
    // Check for successful response
    if (response?.status === 200) {
      return response.data;
    }  else if (response?.status === 201) {
      return response.data;
    }else {
      throw new Error(`Unexpected response status: ${response?.status}`);
    }
  } catch (error) {
    console.error("Error in POST request:", error);
    toast.error(`${error?.response?.data?.message}`);
    // Enhanced error handling
    if (error.response) {
      // Handle server-side errors (e.g., 400, 401, 500)
      throw new Error(`API error: ${error.response?.data || error.message}`);
    } else if (error.request) {
      // Handle network errors (e.g., no response received)
      throw new Error('No response from the server. Please check your network connection.');
    } else {
      // Handle unexpected errors (e.g., invalid configuration)
      throw new Error(`Unexpected error: ${error.message}`);
    }
  }
};

// PUT request
export const putRequest = async (url, data = {}) => {
  try {
    const response = await Api.put(url, data);

    // Check for a successful response
    if (response?.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response?.status}`);
    }
  } catch (error) {
    console.error("Error in PUT request:", error);
    toast.error(`${error?.response?.data?.message}`);
    // Enhanced error handling
    if (error.response) {
      // Handle server-side errors
      throw new Error(`API error: ${error.response?.data || error.message}`);
    } else if (error.request) {
      // Handle network errors
      throw new Error('No response from the server. Please check your network connection.');
    } else {
      // Handle other unexpected errors
      throw new Error(`Unexpected error: ${error.message}`);
    }
  }
};

// DELETE request
export const deleteRequest = async (url, data = {}) => {
  try {
    const response = await Api.delete(url, { data });

    // Check for a successful response
    if (response?.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response?.status}`);
    }
  } catch (error) {
    toast.error(`${error?.response?.data?.message}`);
    console.error("Error in DELETE request:", error);

    // Enhanced error handling
    if (error.response) {
      // Handle server-side errors (e.g., 400, 401, 500)
      throw new Error(`API error: ${error.response?.data || error.message}`);
    } else if (error.request) {
      // Handle network errors (e.g., no response received)
      throw new Error('No response from the server. Please check your network connection.');
    } else {
      // Handle unexpected errors (e.g., invalid configuration)
      throw new Error(`Unexpected error: ${error.message}`);
    }
  }
};



// patch request
export const patchRequest = async (url, data = {}) => {
  try {
    const response = await Api.patch(url, data);

    if (response?.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response?.status}`);
    }
  } catch (error) {
    console.error("Error in PATCH request:", error);
    toast.error(`${error?.response?.data?.message}`);
    if (error.response) {
      throw new Error(`API error: ${error.response?.data || error.message}`);
    } else if (error.request) {
      throw new Error('No response from the server. Please check your network connection.');
    } else {
      throw new Error(`Unexpected error: ${error.message}`);
    }
  }
};